import { commonParams } from "../endpoint/EndpointParameters";
import { de_UpdatePaymentIntentCommand, se_UpdatePaymentIntentCommand, } from "../protocols/Aws_restJson1";
import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class UpdatePaymentIntentCommand extends $Command.classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("TempeFabricationPublic", "UpdatePaymentIntent", {})
    .n("TempeFabricationPublicClient", "UpdatePaymentIntentCommand").f(void 0, void 0)
    .ser(se_UpdatePaymentIntentCommand)
    .de(de_UpdatePaymentIntentCommand)
    .build() {
}
